//document.addEventListener('DOMContentLoaded', function() {

// Função para inicializar os Swipers
function initSwipers() {
  // Swiper Vitrine
  const swiperVitrine = new Swiper('.vitrine-swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    slidesPerGroup: 1,
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 50,
      }
    }
  });

  const swiperImagesVitrine = new Swiper('.vitrine-images-swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    slidesPerGroup: 1,
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 30,
      }
    }
  });

  // Swiper Bebidas
  const swiperBebidas = new Swiper('.bebidas-lista .swiper-bebidas', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    slidesPerView: 3,  // Mostra 3 slides por vez
    slidesPerGroup: 1,
    spaceBetween: 20,
    loop: false,
  });

  // Swiper CarrosselPDP
  if (document.querySelector(".accordion-cafeteiras") !== null) {
    const swiperCarrosselPDP = new Swiper('.accordion-cafeteiras .swiper-container', {
      slidesPerView: 1.3,
      initialSlide: 1,
      loop: true,
      centeredSlides: true,
      spaceBetween: 20,


      navigation: {
        nextEl: '.cafeteiras-next',
        prevEl: '.cafeteiras-prev',
      },
    });


  }

}

// Função para alternar o conteúdo dos botões de descrição
function initDescricaoTabs() {
  const sobreProdutoBtn = document.getElementById('sobreProdutoBtn');
  const infoTecnicasBtn = document.getElementById('infoTecnicasBtn');
  const sobreProdutoContent = document.getElementById('sobreProdutoContent');
  const infoTecnicasContent = document.getElementById('infoTecnicasContent');

  sobreProdutoBtn.classList.add('active');
  sobreProdutoContent.style.display = 'block';

  function showContent(btn, content) {
    document.querySelectorAll('.descricao-btn').forEach(button => button.classList.remove('active'));
    document.querySelectorAll('.descricao-conteudo').forEach(content => content.style.display = 'none');

    btn.classList.add('active');
    content.style.display = 'block';
  }

  sobreProdutoBtn.addEventListener('click', function () {
    showContent(sobreProdutoBtn, sobreProdutoContent);
  });

  infoTecnicasBtn.addEventListener('click', function () {
    showContent(infoTecnicasBtn, infoTecnicasContent);
  });
}

function initAccordion() {
  const accordionHeaders = document.querySelectorAll('.accordion-header');

  accordionHeaders.forEach(header => {
    header.addEventListener('click', function () {
      accordionHeaders.forEach(item => {
        if (item !== this) {
          item.classList.remove('active');
          item.nextElementSibling.style.display = 'none';
        }
      });


      this.classList.toggle('active');

      const content = this.nextElementSibling;
      if (content.style.display === 'block') {
        content.style.display = 'none';
      } else {
        content.style.display = 'block';
      }
    });
  });
}

function init() {
  initSwipers();
  if (document.querySelector(".section-cafeteiras-descricao") !== null) {
    initDescricaoTabs();
  }

  initAccordion();
}


init();


//click on first description - TH
const innerAcordCafeteiras = document.querySelectorAll(".accordion-cafeteiras >div");
if (innerAcordCafeteiras.length > 0) {
  innerAcordCafeteiras[0].querySelector(".accordion-header").click();
}

//});

//document.addEventListener('DOMContentLoaded', function() {
const swiper = new Swiper('.banner-swiper', {
  loop: true,
  spaceBetween: 20,

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  autoplay: {
    delay: 5000,
  },
});


const galleryThumbs = new Swiper('.gallery-thumbs', {
  spaceBetween: 10,
  slidesPerView: 5, // Permite mostrar o número de slides conforme o espaço disponível
  direction: 'vertical',
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
  },
  mousewheel: true, // Habilita a rolagem com o mouse
});




const galleryMain = new Swiper('.gallery-main', {
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  thumbs: {
    swiper: galleryThumbs
  },
  pagination: {
    el: '.swiper-pagination', // Defina um seletor para a div dos "dots"
    clickable: true,          // Permite que os usuários naveguem clicando nos "dots"
  },
});

const swiperItem = new Swiper('.full-banners', {
  loop: true,
  pagination: {
    el: '.swiper-pagination',
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  autoplay: {
    delay: 5000,
  },
});






//});


// Produto específico (ID ou handle)
const targetProductHandle = ['gaggia-classic', 'gaggia-classic-vermelha', 'gaggia-classic-azul'];
const cartItems = {
  items: [
    {
      id: 41070759280715,
      quantity: 1,
    },
    {
      id: 41109548564555,
      quantity: 1,
    }
  ]
}

function updateMiniCart() {
  $.ajax({
    url: '/?section_id=cart-drawer',
    type: 'GET',
    dataType: 'html',
    success: function (carthtml) {
      $('cart-drawer').html($(carthtml).find('cart-drawer').html());
    }
  });
}

//Função para adicionar produtos
function addProduct(handle = false) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(cartItems)
  }).then(() => {
    updateMiniCart();
  })
}

//$(document).ready(() => {
if (location.href.includes("gaggia-classic") || location.href.includes("gaggia-classic-azul") || location.href.includes("gaggia-classic-vermelha")) {

  $("html .cafeteiras-product .product-form__submit").click(() => {
    setTimeout(function () {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const hasTargetProduct = cart.items.some(item => targetProductHandle.includes(item.handle));

          if (hasTargetProduct) {
            addProduct()
          }
        });
    }, 500);
  })
}
//})

if($.fn.slick){
  $('.full-banners .banners.carrossel-enabled').slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
  });
}

// OCULTA PAYPAL PARA COMPRE JÁ
function changeBuyNow(){
	const button = document.querySelector('.shopify-payment-button__more-options');
	button.innerText = 'COMPRE JÁ';
	button.classList.add('show')
	console.log(button);
	console.log('funciona');
}

window.addEventListener('load', function(){
	changeBuyNow();
})
